var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8225 20.8703L24.4895 7.78937C23.1831 6.28196 20.7878 6.28866 19.2703 7.80947L9.95063 17.1454C7.17684 19.9223 6.3829 24.046 7.98754 27.3522C17.5739 47.1997 33.5816 63.2288 53.4166 72.8425C56.7197 74.447 60.8402 73.6531 63.614 70.8761L73.0207 61.4532C74.545 59.929 74.5483 57.5205 73.0274 56.2141L59.8955 44.942C58.522 43.7629 56.3881 43.917 55.0112 45.2971L50.4419 49.8729C50.2079 50.1181 49.9 50.2797 49.5653 50.3329C49.2307 50.3862 48.8878 50.3281 48.5893 50.1677C41.1203 45.8669 34.9247 39.6635 30.6334 32.1893C30.4727 31.8903 30.4145 31.5469 30.4678 31.2117C30.521 30.8765 30.6828 30.568 30.9282 30.3335L35.4842 25.7744C36.8644 24.3876 37.0151 22.2438 35.8225 20.867V20.8703Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.ac6194fecb61d7ab00f692e33289e37f.svg";
export { ForwardRef as ReactComponent };